{
  "label": "Current office",
  "practicePlaceholder": "Current office",
  "addressPlaceholder": "Add street address",
  "editLocation": "Edit location",
  "reviewMatch": "Review match",
  "repeated": "Already submitted in this tab",
  "previewMatch": "Preview match",
  "acknowledged": "Repeat confirmed"
}
